import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StyledBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    width: '660px',
    height: `calc(100vh - ${theme.vpValues.headerHeight + theme.vpValues.appBarHeight}px)`,
    overflowY: 'scroll',
    minHeight: '550px'
  },
  backgroundColor: theme.palette.vpColors.white,
  padding: '20px 20px 100px 20px',
  borderLeft: `1px solid ${theme.palette.vpColors.greyLight}`
}));



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginDetailsForm/styles.js